import { useState } from "react";
import { TbChevronDown } from "react-icons/tb";

const ExpandableSection = ({ title, bodyHtml, id }: { title: string; bodyHtml: string; id?: string }) => {
  const [open, setOpen] = useState(false);

  return (
    <div className="border-b border-[#eee] last:border-b-0">
      <button
        id={id}
        type="button"
        aria-expanded={open}
        onClick={() => setOpen((v) => !v)}
        className="flex cursor-pointer w-full items-center justify-between gap-2 border-0 bg-transparent py-4 text-left"
      >
        <span className="text-[16px] font-medium text-[#1c1917]">{title}</span>
        <TbChevronDown
          size={20}
          className={`shrink-0 text-[#98a0af] transition-transform duration-200 ${open ? "[transform:rotate(180deg)]" : ""}`}
        />
      </button>
      {/* Height animates via grid-template-rows (0fr ↔ 1fr), so the body needs no measured height. */}
      <div className={`grid transition-[grid-template-rows] duration-200 ease-in-out ${open ? "grid-rows-[1fr]" : "grid-rows-[0fr]"}`}>
        <div
          aria-hidden={!open}
          className="min-h-0 w-full overflow-hidden break-words text-[14px] leading-relaxed text-[#616975] [&_li]:mb-[4px] [&_ol]:list-decimal [&_ol]:pl-[20px] [&_p]:mb-[8px] [&_ul]:list-disc [&_ul]:pl-[20px]"
        >
          <div className="pb-[16px]" dangerouslySetInnerHTML={{ __html: bodyHtml }} />
        </div>
      </div>
    </div>
  );
};

export default ExpandableSection;
